import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import actions from '_redux/actions';

import style from '_molecules/ProfileDropdownMobile/index.module.scss';

const ProfileDropdownMobile = ({ name, itens, currentPath }) => {
    const history = useHistory();
    const dispatch = useDispatch();

    const logout = (href) => {
        if (href === '/sair') {
            dispatch(actions.cleanAccommodation());
            dispatch(actions.logout());
            history.push('/entrar');
        }
    };

    return (
        <div className={style.blockDropDownMobile}>
            <div className={classNames(style.trigger)}>
                <div className={classNames(style.name)}>{name}</div>
            </div>
            <div className={style.listLinks}>
                {itens.map((item) => (
                    <Link
                        to={item.href}
                        key={item.href}
                        className={classNames(style.menuItem, {
                            [style.activeItem]: item.href === currentPath,
                        })}
                        onClick={() => logout(item.href)}
                    >
                        {item.text}
                    </Link>
                ))}
            </div>
        </div>
    );
};

ProfileDropdownMobile.propTypes = {
    name: PropTypes.string,
    itens: PropTypes.arrayOf(PropTypes.object),
    currentPath: PropTypes.string,
};

ProfileDropdownMobile.defaultProps = {
    name: undefined,
    itens: '',
    currentPath: undefined,
};

export default ProfileDropdownMobile;
